import {AnimatePresence, motion} from "framer-motion";

import {DECK_SHADOW_DEPTH_COLORS} from "../constants/homematch_tinder_deck_shadows";
import {
    getClampedShadowDepth,
    getDeckShadowDepthMotion,
    getDeckShadowLayerTop,
    getDeckShadowMotionTransition,
    getDeckShadowMotionVariants,
    getDeckShadowZIndex
} from "../utils/deck_shadow_motion";

import * as styles from "./HomematchTinderDeckShadows.module.css";

interface IProps {
    reduceMotion: boolean;
    shadowKeys: number[];
}

export const HomematchTinderDeckShadows = (props: IProps) => {
    const {reduceMotion, shadowKeys} = props;

    return (
        <div aria-hidden className={styles.shadowLayer} style={{top: getDeckShadowLayerTop(shadowKeys.length)}}>
            <AnimatePresence>
                {shadowKeys.map((shadowKey, depth) => {
                    const clampedDepth = getClampedShadowDepth(depth);
                    const target = getDeckShadowDepthMotion(depth);
                    const motionVariants = getDeckShadowMotionVariants(reduceMotion, target);

                    return (
                        <motion.span
                            animate={motionVariants.animate}
                            className={styles.shadowItem}
                            exit={motionVariants.exit}
                            initial={motionVariants.initial}
                            key={shadowKey}
                            style={{
                                backgroundColor: DECK_SHADOW_DEPTH_COLORS[clampedDepth],
                                zIndex: getDeckShadowZIndex(depth)
                            }}
                            transition={getDeckShadowMotionTransition(reduceMotion, depth)}
                        />
                    );
                })}
            </AnimatePresence>
        </div>
    );
};
import {AnimatePresence, motion} from "framer-motion";

import {DECK_SHADOW_DEPTH_COLORS} from "../constants/homematch_tinder_deck_shadows";
import {
    getClampedShadowDepth,
    getDeckShadowDepthMotion,
    getDeckShadowLayerTop,
    getDeckShadowMotionTransition,
    getDeckShadowMotionVariants,
    getDeckShadowZIndex
} from "../utils/deck_shadow_motion";

import * as styles from "./HomematchTinderDeckShadows.module.css";

interface IProps {
    reduceMotion: boolean;
    shadowKeys: number[];
}

export const HomematchTinderDeckShadows = (props: IProps) => {
    const {reduceMotion, shadowKeys} = props;

    return (
        <div aria-hidden className={styles.shadowLayer} style={{top: getDeckShadowLayerTop(shadowKeys.length)}}>
            <AnimatePresence>
                {shadowKeys.map((shadowKey, depth) => {
                    const clampedDepth = getClampedShadowDepth(depth);
                    const target = getDeckShadowDepthMotion(depth);
                    const motionVariants = getDeckShadowMotionVariants(reduceMotion, target);

                    return (
                        <motion.span
                            animate={motionVariants.animate}
                            className={styles.shadowItem}
                            exit={motionVariants.exit}
                            initial={motionVariants.initial}
                            key={shadowKey}
                            style={{
                                backgroundColor: DECK_SHADOW_DEPTH_COLORS[clampedDepth],
                                zIndex: getDeckShadowZIndex(depth)
                            }}
                            transition={getDeckShadowMotionTransition(reduceMotion, depth)}
                        />
                    );
                })}
            </AnimatePresence>
        </div>
    );
};
